module.exports = __webpack_public_path__ + "img/sport-green.924a72f0.jpg";